package pwgs.ui.scenes.acceptinvitationscene

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class AAcceptInvitationControllerFe(props: pwgs.ui.scenes.acceptinvitationscene.AcceptInvitationSceneProps, scene: MAcceptInvitationScene)
 : AController<pwgs.ui.scenes.acceptinvitationscene.AcceptInvitationSceneProps, pwgs.ui.scenes.acceptinvitationscene.AcceptInvitationSceneModel, AcceptInvitationSceneState>(props, scene) {

    val backend = AcceptInvitationControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_load() {
        launchOnDefaultControllerScope {
            render(backend.load())
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class AcceptInvitationControllerBeProxy(private val controller: AAcceptInvitationControllerFe) {

    suspend fun load(): pwgs.ui.scenes.acceptinvitationscene.AcceptInvitationSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.acceptinvitationscene.AcceptInvitationControllerBe.load",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.acceptinvitationscene.AcceptInvitationSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.acceptinvitationscene.AcceptInvitationSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.acceptinvitationscene.AcceptInvitationSceneModel.serializer())
        }
    }

}
